import i18n from "i18next";

export function getLocale(): string {
  const { search } = window.location;
  const params = new URLSearchParams(search);
  const locale = params.get("lang");
  const validLocales = i18n.languages;
  if (locale && validLocales?.includes(locale)) {
    return locale;
  }
  return "en";
}

export const getCurrentLang = (): "en" | "fr" => {
  const firstPath = window.location.pathname.split("/")[1];
  return firstPath === "fr" ? "fr" : "en";
};

export const getUrlLangPrefix = (): string =>
  getCurrentLang() === "fr" ? "/fr" : "";

export const getHomeUrl = (): string =>
  getCurrentLang() === "fr" ? "/fr/" : "/";

export const getSalesPhoneNumber = (): string => {
  let phoneNumber = (import.meta.env.VITE_SALES_PHONE_NUMBER as string) ?? "";
  if (getCurrentLang() === "fr" && import.meta.env.VITE_SALES_PHONE_NUMBER_FR) {
    phoneNumber = import.meta.env.VITE_SALES_PHONE_NUMBER_FR as string;
  }
  return phoneNumber;
};

export const getSalesCalendarLink = (): string => {
  let link = (import.meta.env.VITE_CALENDAR_LINK as string) ?? "";
  if (getCurrentLang() === "fr" && import.meta.env.VITE_CALENDAR_LINK_FR) {
    link = import.meta.env.VITE_CALENDAR_LINK_FR as string;
  }
  return link;
};

export const getPaymentLink = (): string => {
  let link = (import.meta.env.VITE_PAY_LINK as string) ?? "";
  if (getCurrentLang() === "fr" && import.meta.env.VITE_PAY_LINK_FR) {
    link = import.meta.env.VITE_PAY_LINK_FR as string;
  }
  return link;
};
